export enum ThemeVariants {
  Standard = 'themeLight',
  VisualBreak = 'themeVisualBreak',
  JustSuper = 'themeJustSuper',
}
